/* eslint-disable max-lines */
/* eslint-disable sort-keys */
export const audienceMetadataWrapper = {
    backgroundColor: '$metadataBackground',
    border: '1px solid $metadataBorder',
    borderRadius: '$metadataBorder',
    marginBottom: '15px',
    overflow: 'hidden',
    variants: {
        lite: {
            true: {
                backgroundColor: 'transparent',
                border: 0,
                borderRadius: 0,
                padding: 0,
            },
        },
    },
}

export const audienceMetadataHeader = {
    alignItems: 'center',
    background: '$metadataHeaderBackground',
    borderBottom: '1px solid $metadataBorder',
    display: 'flex',
    gap: '10px',
    padding: '$metadataPaddingVertical $metadataPaddingHorizontal',
}

export const audienceMetadata = {
    '&:last-child': {border: 'none'},
    'borderBottom': '1px solid $metadataSectionBorder',
    'display': 'flex',
    'flexDirection': 'column',
    'padding': '$metadataPaddingVertical $metadataPaddingHorizontal',
    'variants': {lite: {true: {}}},
}

export const metadataContainer = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
}

export const header = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
}

export const headerName = {
    '& svg': {
        color: '$icon',
        flex: 'none',
        height: '$metadataHeaderIcon',
        marginRight: '$metadataHeaderIconMargin',
    },
    'color': '$metadataHeaderText',
    'display': 'flex',
    'flexGrow': 1,
    'fontSize': '$metadataHeaderText',
    'fontWeight': '$metadataHeaderText',
}

export const buttonContainer = {
    alignSelf: 'flex-end',
    visibility: 'hidden',
}

export const nestedWrapper = {
    borderLeft: '1px solid $metadataItemBorder',
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '16px',
    paddingLeft: '4px',
}

export const valueWrapper = {
    '&:hover': {backgroundColor: '$metadataItemBackgroundHover'},
    'alignItems': 'center',
    'borderRadius': '$metadataItemBorder',
    'display': 'flex',
    'flex': 1,
    'padding': '$metadataItemPaddingVertical $metadataItemPaddingHorizontal',
    'whiteSpace': 'pre-line',
    'wordBreak': 'break-word',
}

export const keyWrapper = {
    '& span': {wordBreak: 'break-word'},
    'alignItems': 'center',
    'color': '$metadataKey',
    'display': 'flex',
    'flexDirection': 'row',
    'padding': '$metadataItemPaddingVertical $metadataItemPaddingHorizontal',
}

export const keyIcon = {
    '& svg': {height: '12px'},
    'display': 'inline-flex',
    'marginLeft': '8px',
    'variants': {
        type: {
            device: {display: 'none'},
            ninchat: {color: '$metadataIconNinchat'},
            notes: {display: 'none'},
            other: {display: 'none'},
            postAnswers: {display: 'none'},
            preAnswers: {display: 'none'},
            secure: {color: '$metadataIconSecure'},
            sso: {display: '$metadataIconSecure'},
            ssoDelegate: {color: 'none'},
            vars: {display: 'none'},
        },
    },
}

export const item = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
}

export const itemContent = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    variants: {compact: {true: {flexDirection: 'column'}}},
}

export const metadataWrapper = {
    alignItems: 'center',
    display: 'flex',
}

export const actions = {marginTop: '1rem'}

export const ssoMetadata = {margin: '10px 0'}

export const fingerprintWrapper = {'svg ': {color: '$success'}}

export const attachments = {
    display: 'flex',
    gap: '20px',
    padding: '8px',
}

export const attachmentsLabel = {
    color: '$metadataKey',
    flexShrink: 0,
    width: '160px',
}

export const attachmentsFileInfo = {
    minWidth: 0,
    width: '100%',
}

export const attachmentFileInfo = {
    'alignItems': 'center',
    'border': '1px solid $attachmentFileBorder',
    'borderRadius': '10px',
    'display': 'flex',
    'height': '60px',
    'marginBottom': '5px',
    'padding': '3px',
    'width': '100%',
    '&:hover': {
        backgroundColor: '$attachmentFileHoverBackground',
        textDecoration: 'none',
    },
}

export const attachmentImageWrapper = {
    'borderRadius': '10px',
    'height': '100%',
    'marginRight': '10px',
    'width': '60px',
    'overflow': 'hidden',
    'flexShrink': 0,
    '> img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    'variants': {
        hasThumbnail: {
            false: {
                backgroundColor: '$attachmentFileIconBackground',
                color: '$attachmentFileIcon',
                boxSizing: 'border-box',
                padding: '10px',
            },
        },
    },
}

export const attachmentFileName = {
    'width': '100%',
    'minWidth': 0,
    '> div:first-child': {
        color: '$attachmentFileTitle',
        fontWeight: 'bold',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '> div:last-child': {
        color: '$smallText',
        fontSize: '$smallText',
    },
}

export const attachmentFileActions = {
    margin: '0 20px',
    flexShrink: 0,
}

export const attachmentButton = {
    'border': 'none',
    'background': 'none',
    'color': '$attachmentFileDownload',
    'fontWeight': 'bold',
    'alignItems': 'center',
    'borderRadius': '10px',
    'display': 'none',
    'justifyContent': 'center',
    'width': '30px',
    'height': '30px',
    '&:hover': {backgroundColor: '$attachmentFileDownloadLinkHover'},
}
